import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=49122c32&lang=pug&"
import script from "./RegisterConfirm.vue?vue&type=script&lang=js&"
export * from "./RegisterConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports